module.exports = __webpack_public_path__ + "img/大理2.80a61360.jpg";